var _defs, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmallWt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 194.15 233.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009999;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.21 0 83.21 55.47 110.94 55.47 110.94 27.74 166.42 27.74 166.42 166.42 97.08 97.08 27.73 166.42 27.73 27.74 55.47 27.74 55.47 0 0 0 0 233.38 97.08 136.3 194.15 233.38 194.15 0 83.21 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmallWt);
export default __webpack_public_path__ + "static/media/logo-small-wt.234dceb2ecb7048535d4e63413433c94.svg";
export { ForwardRef as ReactComponent };